<template>
  <div :class="$vuetify.breakpoint.name === 'lg' ? 'px-2' : 'px-5'">
    <!-- snackbar -->
    <Snackbar :snackbar="snackbar" :text="text" :timeout="timeout"></Snackbar>
    <!-- end snackbar -->

    <v-row class="mt-3 px-3">
      <v-col cols="12">
        <v-card class="border-radius box-shadow pa-1">
          <v-row>
            <v-col cols="12" class="py-0">
              <v-card-text>
                <div class="color-first title font-weight-bold title mt-3">
                  Surat bebas lab
                </div>

                <!-- row filter -->
                <v-row class="pt-5">
                  <v-col cols="12" md="3">
                    <v-select
                      dense
                      :disabled="process.run"
                      outlined
                      :items="list.status"
                      item-text="status_bebas_lab"
                      item-value="kd_status_bebas_lab"
                      v-model="form.status"
                      v-on:change="onSelectStatus($event)"
                      label="Status"
                      color="#0299B7"
                      hide-details
                      >>
                      <template v-slot:append>
                        <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
                <!-- end row filter -->

                <!-- row  button-->
                <v-row class="mt-8 justify-space-between">
                  <v-col cols="12" md="3">
                    <v-btn
                      @click="toPage('ajukan')"
                      color="#0299B7"
                      elevation="0"
                      :disabled="process.run"
                      class="text-capitalize white--text"
                    >
                      <v-icon size="20" class="mr-3">mdi-plus</v-icon>
                      Ajukan
                    </v-btn>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      :disabled="process.run"
                      outlined
                      dense
                      :hide-details="true"
                      placeholder="Cari . . ."
                      clearable
                      color="#0299B7"
                      class="mx-3"
                      v-model="form.cari"
                      @click:clear="
                        form.cari = '';
                        getList();
                      "
                      v-on:keyup.enter="getList()"
                      prepend-inner-icon="mdi-magnify"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <!-- end row button -->

                <v-card-text
                  class="pa-5 px-0"
                  style="height: calc(100vh - 195px)"
                >
                  <v-skeleton-loader
                    :loading="process.run"
                    transition="scale-transition"
                    :tile="false"
                    :style="process.run ? 'height: calc(100vh - 305px)' : ''"
                    type="table-tbody"
                  >
                    <v-data-table
                      :headers="headers"
                      :items="row"
                      :items-per-page="10"
                      class="elevation-1 required"
                    >
                      <template v-slot:[`item.status`]="{ item }">
                        <td>
                          <span :class="getStatusClass(item.status)">{{
                            item.status
                          }}</span>
                        </td>
                      </template>
                      <template v-slot:[`item.aksi`]="{ item }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              x-small
                              fab
                              icon
                              min-width="25"
                              color="#0299B7"
                              :disabled="process.detail"
                              :loading="process.detail"
                              @click="toPage(item, 'detail')"
                              class="text-capitalize color-first pa-0 mx-1"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-eye</v-icon>
                            </v-btn>
                          </template>
                          <span>Detail</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </v-skeleton-loader>
                </v-card-text>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { TokenService } from "@/service/Storage.Service";
import { get } from "@/service/Axios";
import statusMixin from "@/mixin";
import Snackbar from "@/components/Snackbar.vue";
export default {
  mixins: [statusMixin],
  data() {
    return {
      form: {
        status: "",
        cari: ""
      },
      list: {
        status: []
      },
      process: {
        run: false
      },
      isUII: false,
      row: [],
      headers: [
        {
          text: "No.",
          value: "no",
          sortable: false
        },
        {
          text: "Tanggal pengajuan",
          value: "tanggal_pengajuan",
          sortable: false
        },
        { text: "Status pembayaran", value: "status", sortable: false },
        {
          text: "Proses selanjutnya",
          value: "proses_selanjutnya",
          sortable: false
        },
        {
          text: "Aksi",
          value: "aksi",
          align: "center",
          width: "12%"
        }
      ],
      snackbar: false,
      text: "",
      timeout: 3000
    };
  },

  components: {
    Snackbar
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
    token() {
      return this.$store.state.access_token;
    }
  },

  mounted() {
    TokenService.removeUUID(TokenService.getUuid());
    this.fetch();
  },
  methods: {
    async fetch() {
      this.startLoading();
      const email = this.user.email;
      this.isUII = email.endsWith("uii.ac.id") ? false : true;
      await this.getStatus();
      this.stopLoading();
    },

    async getStatus() {
      try {
        const response = await get(`lab-free-status`);
        if (response.status === 200) {
          const res = response.data.data;
          const status = res.map((el) => ({
            id: el.id,
            kd_status_bebas_lab: el.kdStatusBebasLab,
            status_bebas_lab: el.statusBebasLab,
            proses_selanjutnya: el.prosesSelanjutnya
          }));
          status.unshift({
            id: "all",
            kd_status_bebas_lab: "all",
            status_bebas_lab: "Semua"
          });
          this.list.status = status;
          this.form.status = status[0].id;
        }
      } catch (error) {
        console.log(error);
      }
      await this.getList();
    },

    async getList() {
      this.startLoading();
      try {
        const params = {
          search: this.form.cari,
          id_status_bebas_lab: this.form.status
        };
        const { data, status } = await get("submission-lab-free", { params });
        if (status === 200 && data.data) {
          const row = data.data.map((item, index) => ({
            no: index + 1,
            tanggal_pengajuan: `${this.$callbackdate(item.createdAt)}`,
            status: item.statusSubmission.statusBebasLab,
            proses_selanjutnya: item.statusSubmission.prosesSelanjutnya,
            uuid: item.uuid
          }));
          this.row = row;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.stopLoading();
      }
    },

    onSelectStatus(val) {
      this.form.status = val;
      this.getList();
    },

    toPage(val, page) {
      try {
        TokenService.setUuid(val.uuid);
        const path = page === undefined ? "ajukan" : page;
        if (page === "detail") {
          this.$router.push({
            path: `/surat/ajukan`,
            query: { type: "detail" }
          });
        } else {
          this.$router.push(`/surat/${path}`);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>
